// Environment configuration management
// This file centralizes all environment variable access to avoid hardcoding

interface Environment {
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  SITE_URL: string;
  API_URL: string;
  NODE_ENV: string;
}

// 🔧 React App用の環境変数取得
const getEnvVar = (key: string, fallback?: string): string => {
  // React App用キー（主要）
  const reactAppKey = `REACT_APP_${key}`;
  // Next.js用の環境変数キー（後方互換性）
  const nextPublicKey = `NEXT_PUBLIC_${key}`;
  // window.ENVもprocess.envも使わず、API_URLだけは強制的にローカルAPIを返す
  if (key === 'API_URL') return 'http://localhost:8787/api';
  // それ以外はprocess.envのみ参照
  const value = process.env[reactAppKey] || process.env[nextPublicKey] || fallback;
  
  // 🔧 デバッグ情報（開発環境のみ）
  if (process.env.NODE_ENV === 'development') {
  }
  
  if (!value) {
  }
  
  return value || '';
};

// Environment configuration object
export const env: Environment = {
  SUPABASE_URL: getEnvVar('SUPABASE_URL'),
  SUPABASE_ANON_KEY: getEnvVar('SUPABASE_ANON_KEY'),
  // SITE_URL: getEnvVar('SITE_URL', 'http://localhost:3000'),
  SITE_URL: getEnvVar('SITE_URL', 'https://competencyai-app-l8pci2wl.devinapps.com'),
  API_URL: getEnvVar('API_URL'),
  NODE_ENV: process.env.NODE_ENV || 'development',
};

// Helper functions
export const isLocalDevelopment = (): boolean => {
  // Always use remote Supabase, even in development
  return false;
};

export const getSupabaseUrl = (): string => {
  const url = env.SUPABASE_URL;
  if (process.env.NODE_ENV === 'development') {
  }
  return url;
};

export const getSupabaseAnonKey = (): string => {
  const key = env.SUPABASE_ANON_KEY;
  if (process.env.NODE_ENV === 'development') {
  }
  return key;
};

export const getSiteUrl = (): string => env.SITE_URL;
export const getApiUrl = (): string => {
  const url = env.API_URL;
  if (process.env.NODE_ENV === 'development') {
  }
  return url;
};

// 🔧 起動時の環境変数確認
if (process.env.NODE_ENV === 'development') {
  
  // 🔧 利用可能な環境変数を表示
  const supabaseEnvs = Object.keys(process.env).filter(key => 
    key.includes('SUPABASE') || key.includes('supabase')
  );
}

// Validate required environment variables
const requiredVars = ['SUPABASE_URL', 'SUPABASE_ANON_KEY'];
const missingVars = requiredVars.filter(varName => !env[varName as keyof Environment]);

if (missingVars.length > 0) {
  console.error('❌ Missing required environment variables:', missingVars);
} else {
}